import { BaseModal, ModalOptions, ModalResultType } from "../../../../../core/modal/index";
import { FortumApp } from "../../../../fortumApp";
import { Template } from "../../../../../core/template/index";

import * as turf_help from "@turf/helpers"
import * as turf_pip from "@turf/boolean-point-in-polygon"

export default class DropConfirmModal extends BaseModal
{
    app: FortumApp;
    public template = Template.lazy('/app/views/package_tracking/modals/drop_confirm/index.html');

    locationInput: HTMLInputElement;
    locationList: HTMLDataListElement;
    locationLabel: HTMLSpanElement;

    constructor(items: any[], location: any)
    {
        super();
        this.data.items = items;
        this.data.location = location;
        this.data.dropLocations = [];
    }

    public afterRender(): PromiseLike<void> {
        this.locationInput.addEventListener('click', () => {
            this.locationInput.value = '';
        });
        this.locationInput.addEventListener('change', () => {
            this.locationInput.select();
        });

        setTimeout(() => {
            if (this.data.location != null && this.data.location.position != null) {
                this.app.db.DeliveryLocation.each( (obj) => {
                    let parsed = JSON.parse(obj.geojson);
                    if (parsed != null) {
                        const coordinates = parsed.geometry.coordinates;
                        const pt = turf_help.point([this.data.location.position.coords.longitude, this.data.location.position.coords.latitude]);
                        const poly = turf_help.polygon(coordinates);
                        if (turf_pip.default(pt, poly) == true) {
                            this.data.dropLocations.push(obj);
                        }
                    }
                }).then(() => {
                    let str = '';
                    this.data.dropLocations.forEach((obj) => {
                        str += '<option data-id="' + obj.id + '" value="' + obj.ext_id + ' - ' + obj.description + '" />';
                    });
                    this.locationList.innerHTML = str;
                    if (this.data.dropLocations.length > 0) {
                        this.locationInput.value = this.locationList.options[0].value;
                        this.locationInput.select();
                    } else {
                        this.locationLabel.innerHTML = this.pgettext('Package', 'No locations available, scan from QR code');
                        this.locationInput.select();
                    }
                });
            } else {
                if (this.data.location != null) {
                    this.locationLabel.innerHTML = this.pgettext('Package', 'Geolocation was not available, scan from QR code');
                }
            }

            if (this.data.items.length > 0) {
                this.getTransportationUnitName(this.data.items[0].item.tup_id);
            }
            this.locationInput.focus();
        });

        return super.afterRender();
    }

    private getTransportationUnitName(tupId) {
        let tupName = '';
        this.app.db.TransportationUnit.get(tupId).then(tup => {
            if (tup) {
                document.querySelectorAll("[id='PackageTranspointationUnit']").forEach( (elem) => {
                    (<HTMLScriptElement>elem).innerHTML = tup.name;
                });
            } else {
                // Local data not available, go to network
                const tup = this.app.api.private('pt_transportation_unit_info', {package_tag: tupId});
            }
        }).catch(() => {
            document.querySelectorAll("[id='PackageTranspointationUnit']").forEach( (elem) => {
                (<HTMLScriptElement>elem).innerHTML = '';
            });
        });
    }

    public get defaults(): ModalOptions
    {
        return {
            title: this.pgettext('Title', 'Confirm drop')
        }
    }

    public onCancelClicked(e: Event)
    {
        this.close(ModalResultType.CANCEL);
    }

    public onSubmitClicked(e: Event)
    {
        const selected = (<HTMLDataListElement>this.locationList.querySelector('option[value="' + this.locationInput.value + '"]'));
        let id = null;
        if (selected != null) {
            id = selected.dataset.id;
        }
        this.close(ModalResultType.OK, { location_id: id,  location_text: this.locationInput.value });
    }
}